module.exports = __webpack_public_path__ + "static/media/properties.d852f03e.png";